<template>
	<!-- 导航 -->
  <div class="header-wrap">
    <div class="tips-bar white-bar" :class="{'white-bar':$store.state.showWhiteHeader}">
      <div class="content">
        <span style="color:#4A4A4A;">
          欢迎来到广州公证处区块链赋强公证系统网站！
        </span>
        <div class="beidou-time">
          <!-- <span ><a href="javascript:;" @click="openUrl('/user/register')">免费注册</a></span> -->
          <!-- <span ><a href="javascript:;" v-if= 'this.isNotaryOfficeLogin' @click="openUrl('/index/notaryOfficeLogin')">公证人员专用入口</a></span> -->
          <!-- <span>|</span> -->
          <!-- <span><a href="javascript:;" v-if= '!this.isNotaryOfficeLogin'  @click="openUrlLogin('/index/home')">返回首页</a></span> -->
          <p><img alt="" src="../../assets/images/index/technology_icon.png"/><span>技术支持热线：199-2600-3061</span> <img alt="" src="../../assets/images/index/beidou_time_icon.png"/><span style="width: 244px;">北斗卫星授时 ：{{beidouTime}}</span></p>
          
        </div>
      </div>
    </div>
  	<div :class="{'nav': true,'nav-fix': headerIsfix,'nav-normal': !headerIsfix, 'border-change': isWhite}">
      <div class="shadow"></div>
      <div class="nav-con" :class="{'bg-is-White': isWhite}">
        <div class='logo'>
          <div class="content">
            <div class="logo-con">
              <a v-on:click="handelLink()" style="cursor: pointer;"><img src="../../assets/images/index/logo.png"></a>
              <p class="validation" @click="$router.push('/verification/validate')">合同验证</p>
              <div class="code_img_con">
                <!-- <p>
                  <img src="../../assets/images/index/app_code.png"/>
                  <span>赋强公证小程序</span>
                </p> -->
                
                <p>
                  <img src="../../assets/images/index/wxgzh.png"/>
                  <span>微信公众号</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- <ul class="clearfix">
          <li v-for="item in headerObj">
            <a
              href="javascript:;"
              :class="{cur: item.current}"
              @click="changeNav(item, headerObj)"
            >
              {{item.showName}}
            </a>
          </li>
          <div class="line"></div>
        </ul> -->
      </div>
         <!-- <div class='logos'>
           <div class="content">
             <div class="nav_list">
               <router-link class="nav_list_item" v-for="(item,index) in headerObj" :key="index" tag="span" :to="item.path">{{item.showName}}</router-link>
             </div>
         	  <a href='https://www.legalxchain.com/cn/blockChain' target="_blank" style="cursor: pointer;"><img src="../../assets/images/index/legaxchain_logo_img.png"></a>
           </div>
        </div> -->
  	</div>
  </div>
</template>

<script>
import moment from "moment";
import BaseApi from "@lib/baseApi.js";
export default {
  name: 'HeaderArea',
  props: ['headerIsfix'],
  data () {
    return {
      oldIP360Url: '',
      isWhite: false,
      headerObj: [
        // {
        //   path: '/index/home',
        //   title: 'home',
        //   showName: '首页',
        //   current: true,
        // },
        // {
        //   path: '/index/notaryOfficeLogin',
        //   title: 'notaryOfficeLogin',
        //   showName: '公证员入口',
        //   current: false,
        // },
        // {
        //   path: '/info/extractLogin',
        //   title: 'extractLogin',
        //   showName: '证据提取',
        //   current: false,
        // },
        // {
        //   path: '/info/validateQuery',
        //   title: 'validateQuery',
        //   showName: '查询验证',
        //   current: false,
        // },
        // {
        //   path: '/index/notaryOfficeLogin',
        //   title: 'notaryOfficeLogin',
        //   showName: '公证机构入口',
        //   current: false,
        // },
        // {
        //   path: '/info/product',
        //   title: 'product',
        //   showName: '产品及服务',
        //   current: false,
        // },
        // {
        //   path: '/info/OpenPlatform',
        //   title: 'OpenPlatform',
        //   showName: '开放平台',
        //   current: false,
        // },
        // {
        //   path: '/info/about',
        //   title: 'about',
        //   showName: '关于我们',
        //   current: false,
        // },
      ],
      beidouTime: '',
      counterID: '',
      isNotaryOfficeLogin: true, //是否为公证人员入口
    }
  },
  mounted(){
    this.init()
    // //console.log("showWhiteHeader:", this.$store.state.showWhiteHeader)
    if(this.$store.state.showWhiteHeader){
      this.isWhite = true
    }else{
      this.isWhite = false
    }
    this.isNotaryOfficeLogin = this.$route.path =="/index"
  },
  methods:{
    init(){
      if(this.$route.path=="/user/register" || this.$route.path=="/user/agreement" || this.$route.path =="/user/resetPassword"){
        $('.nav_list_item').eq(0).addClass("router-link-active")
      }
      this.getTime();
    },
    getTime(){
       BaseApi.createRpcToken("/getTimes").then(response => {
      let seed = response.serverTime;
        if(seed){
          let gap = Date.now() - seed;
          if(this.counterID){
            clearInterval(this.counterID);
          }
          this.counterID = setInterval(()=>{
            this.beidouTime = moment(Date.now() + gap).format("YYYY-MM-DD HH : mm : ss SSS");
          }, 100)
        }
      },
      data => {
       
      }
    )
    .catch(function(e) {
      errorLog(e);})
    },
    openUrl(url){
      this.$router.push(url);
      this.isNotaryOfficeLogin=="/index/notaryOfficeLogin"
    },
    openUrlLogin(url){
      let re = this.$route.query.redirect
      if(re){
        let redirectUrl = `${url}?redirect=${re}`
        this.$router.push(redirectUrl)
      }else{
        this.$router.push(url)
      }
    },
    handelLink(){
      this.$router.push('/index')
    },
    changeNav (item, list) {
      list.forEach((item, index) => {
        item.current = false
      } )
      item.current = true
      this.$router.push(item.path)
    }
  },
  watch:{
    headerIsfix () {
      if (this.headerIsfix) {
        this.isWhite = true
        $('.nav-con ul li a').css({color: '#333'})
        $('.nav .shadow').animate({
          opacity:0,
        })
      } else {
        this.isWhite = false
        $('.nav-con ul li a').css({color: '#000'})
        $('.nav .shadow').animate({
          opacity: 0,
        })
      }
    },
    '$store.state.showWhiteHeader' () {
      if (this.$store.state.showWhiteHeader) {
        this.isWhite = true
      } else {
        this.isWhite = false
      }
    },
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/scss/base.scss';
.header-wrap{
  width: 100%;
}
.tips-bar{
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  color: #000;
  background-color: #ffffff;
}
.white-bar{
  background: #F0F0F0;
  border-bottom:1px solid #e8e8e8;
  color:#666;
}
.tips-bar .content{
  width: 1200px;
  height: 100%;
  margin:0 auto;
}
.tips-bar .content .beidou-time{
  float: right;
  width: 515px;
}

.tips-bar .content .beidou-time p{
  display: flex;
  color: #969696;
  align-items: center;
  justify-content: flex-end;
  img{
    width: 12px;
    height: 12px;
    margin-left:  9px;
    margin-right: 3px;
  }
}
.tips-bar .content span,.tips-bar .content .beidou-time span{font-size: 12px;}
.tips-bar .content .beidou-time span:hover a{
  color: $text!important;
}
/*导航logo*/
.nav {
    width:100%;
    height: 112px;
    // padding: 5px 0;
    font-size: 15px;
    background:#FFFFFF;
    position: relative;
    .validation{
      // width: 412px;
      text-align: center;
      display: inline-block;
      margin-left: 44px;
      margin-top: 10px;
      cursor: pointer;
      flex-shrink: 0;
      color:#666666;
    }
    .validation:hover{
      color: #c41515;
    }
    
}
.nav .shadow{
  width: 100%;
  height: 112px;
  position: absolute;
  left:0;
  top:0;
  background:#fff;
  opacity: 0;
}
.nav .nav-con{
  width: 1200px;
  margin:0 auto;
  height: 112px;
  position: relative;
  display: flex;
  align-items: center;
}
.nav .logo {
    width: 621px;
    height: 112px;
    // float: left;
}
.nav .logo a {
    display: block;
    width: 621px;
    height: 44px;
    flex-shrink: 0;
    img{
      width: 100%;
    }
}
.logo-con{
  width: 1200px;
  display: flex;
  justify-content:space-between;
  align-items: center;
  height: 100%;
}
.code_img_con{
  display: flex;
  width: 100%;
  justify-content: flex-end;
  height: 112px;
  align-items: center;
  p{
    width: 84px;
    text-align: center;
    display: inline-block;
    font-size: 12px;
    font-weight: 500;
    color: #343333;
  }
  p:nth-child(2){
    margin-left: 12px;
  }
  img{
    display: block;
    margin: 0 auto;
    width: 76px;
    height: 76px;
    margin-bottom: 3px;
  }
}
/*导航内容*/
.nav ul{
  float: right;
  position: relative;
}
.nav ul li{
  float: left;
  padding:0 18px;
  height: 61px;
  line-height: 61px;
  color: #2d2d2e;
  /* color: #fff; */
}
.nav ul li a{
  /* color:#fff; */
  color: #2d2d2e;
  display: block;
  height: 52px;
}
.nav ul li a:hover{
  color:$bg;
  display: inline-block;
  /*border-bottom:3px solid #e2344a;*/
}

.nav .bg-is-White ul li a{
  color: #2d2d2e;
}
.nav .bg-is-White ul li a:hover{
  color: $bg;
}
.border-change{
  border-bottom:1px solid #e4e4e4;
}
.nav-fix{
  position: fixed;
  top:0;
}

.cur{
  color: $bg!important;
  border-bottom:3px solid $bg;
}

.line{
  height: 3px;
  width: 0;
  background: $bg;
  position: absolute;
  bottom:9px;
}
.logos{
  // float: right;
  background: $bg;
  height: 44px;
  border-bottom: 1px solid $navactive;
  .content{
    width: 1200px;
    margin:0 auto;
    height: 100%;
    .nav_list{
      color: #fff;
      float: left;
      span{
        cursor:pointer;
        display: inline-block;
        min-width: 110px;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        text-align: center;
        line-height: 44px;
      }
      .router-link-active{
        background: $navactive;
      }
      span:hover{
        background: $navactive;
      }
    }
    a{
      width: 200px;
      height: 22px;
      display: inline-block;
      float: right;
      margin-top:12px;
      img{
        width: 100%;
      }
  }
  }
  
}
</style>
